import { Button, mergeClasses } from "@fluentui/react-components";
import React, { useCallback } from "react";
import { buttonStyles } from "../../../styles/buttonStyles";
import { AIRPORT_VIEWS } from "../../../utils/maps/MapConstants";
import { mapLibreControlsStyles } from "../map-displays/mapStyles";

interface AirportViewControlsProps {
  onViewChange: (zoom: number) => void;
}

const AirportViewControls: React.FC<AirportViewControlsProps> = ({
  onViewChange,
}) => {
  const styles = mapLibreControlsStyles();
  const buttonClasses = buttonStyles();

  const handleViewChange = useCallback(
    (zoom: number) => () => onViewChange(zoom),
    [onViewChange]
  );

  return (
    <section
      className={mergeClasses(styles.cardContainer, styles.viewControls)}
    >
      <span className={styles.viewControlsLabel}>Airport Views</span>
      {AIRPORT_VIEWS.map(({ label, zoom }) => (
        <Button
          key={zoom}
          className={mergeClasses(buttonClasses.applyButton, styles.viewButton)}
          size="small"
          onClick={handleViewChange(zoom)}
        >
          {label}
        </Button>
      ))}
    </section>
  );
};

export default AirportViewControls;
